export var ETestReportType;
(function (ETestReportType) {
    ETestReportType[ETestReportType["\u975E\u68C0\u6D4B\u7C7B"] = 0] = "\u975E\u68C0\u6D4B\u7C7B";
    ETestReportType[ETestReportType["\u68C0\u6D4B\u7C7B"] = 1] = "\u68C0\u6D4B\u7C7B";
})(ETestReportType || (ETestReportType = {}));
export var ELicenseTypeAttr;
(function (ELicenseTypeAttr) {
    ELicenseTypeAttr[ELicenseTypeAttr["\u4F01\u4E1A\u8BC1\u7167"] = 1] = "\u4F01\u4E1A\u8BC1\u7167";
    ELicenseTypeAttr[ELicenseTypeAttr["\u8D27\u54C1\u8BC1\u7167"] = 2] = "\u8D27\u54C1\u8BC1\u7167";
})(ELicenseTypeAttr || (ELicenseTypeAttr = {}));
